
import photosnap from '../images/photosnap.svg';
import manage from '../images/manage.svg';
import account from '../images/account.svg';
import myhome from '../images/myhome.svg';
import loopStudios from '../images/loop-studios.svg';
import faceit from '../images/faceit.svg';
import shortly from '../images/shortly.svg';
import insure from '../images/insure.svg';
import eyecamCo from '../images/eyecam-co.svg';
import theAirFilterCompany from '../images/the-air-filter-company.svg';

const svgMap = {
  'photosnap.svg': photosnap,
  'manage.svg': manage,
  'account.svg': account,
  'myhome.svg': myhome,
  'loop-studios.svg': loopStudios,
  'faceit.svg': faceit,
  'shortly.svg': shortly,
  'insure.svg': insure,
  'eyecam-co.svg': eyecamCo,
  'the-air-filter-company.svg': theAirFilterCompany,
};

export default svgMap;
